import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import Entdecken from "@/pages/Entdecken";
import Pflege from "@/pages/Pflege";
import Fotografie from "@/pages/Fotografie";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const RequireAuth = ({ children }) =>
  localStorage.getItem("artpart_token") ? children : <Navigate to="/admin/login" replace />;

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/entdecken" element={<Entdecken />} />
          <Route path="/pflege" element={<Pflege />} />
          <Route path="/fotografie" element={<Fotografie />} />
          <Route path="/impressum" element={<LegalPage type="impressum" />} />
          <Route path="/datenschutz" element={<LegalPage type="datenschutz" />} />
          <Route path="/versand" element={<LegalPage type="versand" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
